<template>
    <div class="widget p-3 my-3">
        <div class="w-100 d-flex justify-content-between align-items-center">
            <h5 class="py-3">{{ report.title }}</h5>
        </div>
        <p class="font-italic mb-4">Outputs: {{ report.outputs }}</p>

        <p class="text-muted" v-if="report.fields.length || report.range">Parameters</p>

        <template v-for="field in report.fields">
            <div class="row mb-3">
                <div class="col-6 col-sm-3">
                    <label class="font-weight-bold mb-0">{{ field.name }}:</label>
                </div>
                <div class="col-6 col-sm-4">
                    <select
                        name="billing-therapist-id"
                        id="billing-therapist-id"
                        class="form-control form-control-sm"
                        v-model="parameters[field.prop]"
                    >
                        <option selected :value="null" v-if="field.option_null">{{
                            field.option_null
                        }}</option>
                        <option
                            v-for="option in field.options"
                            :value="option[field.option_value]"
                            >{{ option[field.option_title] }}</option
                        >
                    </select>
                </div>
            </div>
        </template>

        <div class="row mb-3" v-if="report.range">
            <div class="col-6 col-sm-3">
                <label class="font-weight-bold mb-0">Date range:</label>
            </div>
            <div class="col-6 col-sm-4">
                <div class="d-flex">
                    <div class="d-flex align-items-center">
                        <v-date-picker
                            class="form-control form-control-sm"
                            popover-align="right"
                            v-model="parameters.start_date"
                        ></v-date-picker>
                    </div>
                    <label class="mx-3 mb-0">to</label>
                    <div class="d-flex align-items-center">
                        <v-date-picker
                            class="form-control form-control-sm"
                            popover-align="right"
                            v-model="parameters.end_date"
                        ></v-date-picker>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-100 d-flex justify-content-end">
            <button
                class="btn btn-sm btn-primary font-weight-bold"
                id="download-billing-report"
                @click="$emit('generate-report', parameters)"
            >
                Export
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "ReportModule",
    props: ["report"],
    data() {
        return {
            parameters: {},
        };
    },
    mounted() {
        this.setDefaultsToNull();
    },
    watch: {
        report() {
            this.setDefaultsToNull();
        },
    },
    methods: {
        setDefaultsToNull() {
            this.report.fields.forEach(field => {
                this.$set(this.parameters, field.prop, null);
            });
        },
    },
};
</script>

<style scoped></style>
